export default [
  {
    path: "ofertas",
    name: "offers",
    redirect: { name: "offers-list" },
    children: [
      {
        path: "",
        name: "offers-list",
        component: () => import("@/modules/offers/views/OffersList.vue"),
      },
      {
        path: "ver/:id",
        name: "offers-show",
        component: () => import("@/modules/offers/views/OffersShow.vue"),
      },
    ],
  },
];
